<div *ngIf="score !== null && score !== undefined" class="bar">
  <div class="fill" [style.width]="fillWidth"></div>
</div>
